// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BookmarkUpdateController from "./bookmark_update_controller"
application.register("bookmark-update", BookmarkUpdateController)

import HeaderController from "./header_controller"
application.register("header", HeaderController)

import LinkController from "./link_controller"
application.register("link", LinkController)

import Modal__OpenController from "./modal/open_controller"
application.register("modal--open", Modal__OpenController)

import ToastrController from "./toastr_controller"
application.register("toastr", ToastrController)

import TweetRecommendController from "./tweet_recommend_controller"
application.register("tweet-recommend", TweetRecommendController)

import HomeScreenGuideController from "./home_screen_guide_controller"
application.register("home-screen-guide", HomeScreenGuideController)